/* eslint-disable promise/always-return */
/* eslint-disable no-console */

import 'react-js-cron/dist/styles.css';
import { API } from '../../api';
import {
  Button,
  Drawer,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Popconfirm,
  Select,
  Space,
  Spin,
  Switch,
  Table,
  Tooltip,
  notification,
} from 'antd';
import { Cron } from 'react-js-cron';
import {
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
  MoreOutlined,
  PlayCircleOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  StopOutlined,
} from '@ant-design/icons';
import { DimaContext } from '../../DimaContext';
import { Link, useRouteMatch } from 'react-router-dom';
import { USER_ROLE } from '../../consts';
import { checkPermission, isAdmin } from '../../utils/util';
import JobBuildInputs from './jobBuildInputs';
import React, { useContext, useEffect, useState } from 'react';
import cronstrue from 'cronstrue';

/**
 * Lists all ingestion Schedules for a client.
 */
const Schedules = props => {
  const { selectedClient } = props;
  const { TextArea } = Input;
  const dimaContext = useContext(DimaContext);
  const canEdit = process.env.REACT_APP_FEATURE_PERMISSIONS_V2
    ? checkPermission(dimaContext.userData.permissions, 'editClient')
    : isAdmin(USER_ROLE);
  const [form] = Form.useForm();
  const [schedules, setSchedules] = useState([]);
  const [jobTypes, setJobTypes] = useState([]);
  const [inputFields, setInputFields] = useState({});
  const [inputDescr, setInputDescr] = useState({});
  const [cronString, setCronString] = useState('0 0 * * *');
  const [isActive, setIsActive] = useState(true);
  const [editJobType, setEditJobType] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [editedSchedule, setEditedSchedule] = useState('');
  const [jobTypeDesc, setJobTypeDesc] = useState('');
  const [schedId, setSchedId] = useState(null);
  const [newSchedModal, setNewSchedModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [hasRouteOn, setHasRouteOn] = useState(false);
  // const [payloadInputFields, setPayloadInputFields] = useState([]);
  const { url } = useRouteMatch();

  const readableCronString = cron => {
    return `${cronstrue.toString(cron, { verbose: true })} (UTC)`;
  };

  const validateCron = () => {
    const cronList = cronString.split(' ');

    if (cronList[0] === '*' && cronList[1] === '*') {
      return `Scheduled frequency is too high (${readableCronString(cronString)}),
      this will incur high AWS costs. Are you sure you want to schedule this job?`;
    }

    return 'Are you sure?';
  };

  const validateRouting = routing => {
    try {
      JSON.parse(routing);
      return true;
    } catch (e) {
      notification.error({
        message: 'Error',
        description: 'Routing field must be passed a valid JSON Array',
        duration: 3,
        placement: 'topLeft',
      });
      return false;
    }
  };

  // TODO: confirm clearing works as expected
  const handleClearForm = () => {
    setInputFields({});
    setInputDescr({});
    setCronString('0 0 * * *');
    setEditedSchedule(null);
    setHasRouteOn(false);
    // clear form values
    form.setFieldsValue({
      schedule_name: null,
      job_type: null,
      active: null,
      routing: null,
    });
  };

  const toggleNewJobScheduleDrawer = () => {
    handleClearForm();
    setNewSchedModal(!newSchedModal);
  };

  const toggleEditModal = () => {
    if (editModal) handleClearForm();
    setEditModal(!editModal);
  };

  const toggleIsActive = () => {
    setIsActive(!isActive);
  };

  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const toggleDeleteSchedule = sched => {
    setSchedId(sched.id);
    setCronString(sched.cron);
    setJobTypeDesc(`${sched.jobType.name}: ${sched.jobType.description}`);
    setEditedSchedule(sched);
    setDeleteModal(true);
  };

  const toggleEditSchedule = sched => {
    setSchedId(sched.id);
    setCronString(sched.cron);
    setEditJobType(sched.jobType);
    setEditedSchedule(sched);
    setInputFields(sched.payload);
    setEditModal(true);
  };

  const handleDeleteSchedule = async () => {
    // get client job types from DIS API /jobtypes endpoint
    await API.delete(`/dis/schedules?clientId=${selectedClient.id}&scheduleId=${editedSchedule.id}`)
      .then(res => {
        if (res.status === 200) {
          const currSchedules = schedules.filter(s => s.id !== editedSchedule.id);
          setSchedules(currSchedules);
        } else {
          throw Error('Error deleting schedule');
        }
      })
      .catch(() => {
        notification.error({
          message: 'Error',
          description: `Unable to delete schedule: ${editedSchedule.name}`,
          duration: 3,
          placement: 'topLeft',
        });
      });
    setDeleteModal(false);
    handleClearForm();
  };

  const getJobTypeRouting = name => {
    // set jobtype routing
    for (const jobType of jobTypes) {
      if (jobType.value === name) {
        setHasRouteOn(jobType.routing !== null);
      }
    }
  };

  const handleGetInputFields = async () => {
    const jobType = form.getFieldValue('job_type') ?? null;
    getJobTypeRouting(jobType);
    // get client inputFields for selected jobType from DIS API
    await API.get(`/dis/fields?clientId=${selectedClient.id}&jobType=${jobType}`)
      .then(res => {
        const fields = {};
        const descr = {};

        for (const field of res.data) {
          fields[field.name] = editedSchedule ? editedSchedule.payload[field.name] : null;
          descr[field.name] = field.description;
        }

        setInputFields(fields);
        setInputDescr(descr);
      })
      .catch(() => {
        notification.error({
          message: 'Error',
          description: 'Unable to get Input Fields for selected Job Type',
          duration: 3,
          placement: 'topLeft',
        });
      });
  };

  const handleVersions = jobSchedules => {
    let latestSchedules = [];

    const results = {};
    jobSchedules.forEach(sched => {
      if (!results[sched.id]) {
        results[sched.id] = sched;
      }

      if (results[sched.id]) {
        if (results[sched.id].version < sched.version) {
          results[sched.id] = sched;
        }
      }
    }, Object.create(null));

    latestSchedules = Object.keys(results).map(key => results[key]);
    return latestSchedules;
  };

  const getSchedules = async () => {
    // get client schedules from DIS API /schedules endpoint
    await API.get(`/dis/schedules?clientId=${selectedClient.id}`)
      .then(res => {
        const jobSchedules = handleVersions(res.data.results);
        setSchedules(jobSchedules);
      })
      .catch(() => {
        notification.error({
          message: 'Error',
          description: `Unable to get Schedules for client: ${selectedClient.name}`,
          duration: 3,
          placement: 'topLeft',
        });
      });
  };

  const getJobTypes = async () => {
    await API.get(`/dis/jobTypes?clientId=${selectedClient.id}`)
      .then(res => {
        setJobTypes(
          res.data.results.map(jobType => ({
            value: jobType.name,
            label: `${jobType.name}: ${jobType.description}`,
            routing: jobType.routeOn,
          })),
        );
      })
      .catch(() => {
        notification.error({
          message: 'Error',
          description: `Unable to get Job Types for client: ${selectedClient.name}`,
          duration: 3,
          placement: 'topLeft',
        });
      });
  };

  const getPayload = values => {
    const payload = {};

    for (const field of Object.keys(inputFields)) {
      payload[field] = values[field];
    }

    return payload;
  };

  const onFinishFailed = errorInfo => {
    console.log('Failed: ', errorInfo);
  };

  const onCreateSchedule = async values => {
    let newSchedule = null;

    if (hasRouteOn && validateRouting(values.routing)) {
      newSchedule = {
        name: values.schedule_name,
        jobType: values.job_type,
        userId: dimaContext.userData.userId,
        active: isActive,
        cron: cronString,
        payload: getPayload(values),
        routing: JSON.parse(values.routing) ? JSON.parse(values.routing) : [],
      };
    } else if (!hasRouteOn) {
      newSchedule = {
        name: values.schedule_name,
        jobType: values.job_type,
        userId: dimaContext.userData.userId,
        active: isActive,
        cron: cronString,
        payload: getPayload(values),
      };
    }

    if (selectedClient.use_multitenant_config) {
      newSchedule.dimaId = selectedClient.id;
    }

    if (newSchedule !== null) {
      setLoading(true);

      await API.post(`/dis/schedules?clientId=${selectedClient.id}`, newSchedule)
        .then(() => {
          notification.success({
            message: 'Success!',
            description: `Schedule, ${newSchedule.name}, has been successfully added to ${selectedClient.name}`,
            duration: 3,
            placement: 'topLeft',
          });
        })
        .catch(e => {
          const err = e.response.data ? JSON.stringify(e.response.data) : e;
          notification.error({
            message: 'Error',
            description: `There was an error creating the Schedule: ${err}`,
            duration: 3,
            placement: 'topLeft',
          });
        });

      await getSchedules();
      setLoading(false);
      setNewSchedModal(false);

      handleClearForm();
      setCronString('0 0 * * 0');
    }
  };

  const onSubmitEdit = async values => {
    let updatedSchedule = null;

    if (hasRouteOn && validateRouting(values.routing)) {
      updatedSchedule = {
        jobType: values.job_type,
        name: values.schedule_name,
        cron: cronString,
        active: editedSchedule.active,
        payload: getPayload(values),
        routing: JSON.parse(values.routing),
        userId: dimaContext.userData.userId,
      };
    } else if (!hasRouteOn) {
      updatedSchedule = {
        jobType: values.job_type,
        name: values.schedule_name,
        cron: cronString,
        active: editedSchedule.active,
        payload: getPayload(values),
        userId: dimaContext.userData.userId,
      };
    }

    if (updatedSchedule !== null) {
      setLoading(true);

      await API.patch(
        `/dis/schedules?clientId=${selectedClient.id}&scheduleId=${schedId}`,
        updatedSchedule,
      )
        .then(() => {
          notification.success({
            message: 'Success!',
            description: `Schedule, ${updatedSchedule.name}, has been successfully updated`,
            duration: 3,
            placement: 'topLeft',
          });
        })
        .catch(e => {
          const err = e.response.data ? JSON.stringify(e.response.data) : e;
          notification.error({
            message: 'Error',
            description: `${err}`,
            duration: 3,
            placement: 'topLeft',
          });
        });
      await getSchedules();
      setLoading(false);
      setEditModal(false);
      handleClearForm();
    }
  };

  const onToggleScheduleStatus = async (schedule, activeStatus) => {
    const msg = activeStatus ? 'started' : 'stopped';
    setLoading(true);
    const updatedSchedule = {
      jobType: schedule.jobType.name,
      cron: schedule.cron,
      payload: schedule.payload,
      routing: schedule.routing,
      name: schedule.name,
      active: activeStatus,
      userId: dimaContext.userData.userId,
    };

    setLoading(true);

    await API.patch(
      `/dis/schedules?clientId=${selectedClient.id}&scheduleId=${schedule.id}`,
      updatedSchedule,
    )
      .then(() => {
        notification.success({
          message: 'Success!',
          description: `Schedule, ${schedule.name}, has been successfully ${msg}`,
          duration: 3,
          placement: 'topLeft',
        });
      })
      .catch(e => {
        notification.error({
          message: 'Error',
          description: `There was an error updating Schedule, ${schedule.name}: ${e}`,
          duration: 3,
          placement: 'topLeft',
        });
      });

    await getSchedules();
    setLoading(false);
    setEditModal(false);
    handleClearForm();
  };

  const cronJob = (
    <>
      <div style={{ width: '100%' }}>
        <Cron value={cronString} setValue={setCronString} clockFormat="12-hour-clock" />
      </div>
      <p>This job is scheduled to run {readableCronString(cronString)}</p>
    </>
  );

  const generateColumns = () => {
    return [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: (a, b) => {
          if (a.name === null || b.name === null) return 1;
          return a.name.localeCompare(b.name);
        },
        render: (name, record) => {
          const linkUrl = `${url}/schedule/${record.id}`;
          return (
            <Link to={linkUrl} data-cy={`schedule-${name.replace(' ', '-')}`}>
              {name}
            </Link>
          );
        },
      },
      {
        title: 'Schedule',
        dataIndex: 'cron',
        key: 'cron',
        sorter: (a, b) => {
          if (a.cron === null || b.cron === null) return 1;
          return a.cron.localeCompare(b.cron);
        },
        render: cron => `${readableCronString(cron)} (${cron})`,
      },
      {
        title: 'Job Type',
        dataIndex: 'jobType',
        key: 'jobType',
        sorter: (a, b) => {
          if (a.name === null || b.name === null) return 1;
          return a.jobType.localeCompare(b.jobType);
        },
        render: jobType => {
          const linkUrl = `${url}/jobType/${jobType}`;
          return (
            <Link to={linkUrl} data-cy={`jobType-link-${jobType}`}>
              {jobType}
            </Link>
          );
        },
      },
      {
        title: 'Status',
        dataIndex: 'active',
        key: 'active',
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.active - b.active,
        render: active => (active === true ? 'Active' : 'Stopped'),
      },
      {
        title: 'Action',
        align: 'center',
        render: record => {
          return (
            <Space size="middle" style={{ marginRight: '15px' }}>
              <Dropdown.Button
                trigger={['click']}
                data-cy="dropDown"
                overlayStyle={{
                  border: '1px solid #d9d9d9',
                  borderRadius: 2,
                }}
                icon={<MoreOutlined id={`dropdownExtension${record.id}`} />}
                overlay={
                  <Menu>
                    <Menu.Item
                      key="1"
                      id={`edit-job-${record.id}`}
                      onClick={() => toggleEditSchedule(record)}
                      disabled={!canEdit}
                      icon={<EditOutlined />}
                      type="primary"
                      data-cy="editSchedule"
                    >
                      Edit
                    </Menu.Item>
                    <Menu.Item
                      key="2"
                      id={`delete-job-${record.id}`}
                      onClick={() => toggleDeleteSchedule(record)}
                      disabled={!canEdit}
                      icon={<DeleteOutlined />}
                      type="primary"
                      data-cy="deleteSchedule"
                    >
                      Delete
                    </Menu.Item>
                    {record.active === true && (
                      <Menu.Item
                        key="3"
                        id={`stop-job-${record.id}`}
                        onClick={() => onToggleScheduleStatus(record, false)}
                        disabled={!canEdit}
                        icon={<StopOutlined />}
                        type="primary"
                        data-cy="stopSchedule"
                        visible={record.active === true}
                      >
                        Stop
                      </Menu.Item>
                    )}
                    {record.active === false && (
                      <Menu.Item
                        key="4"
                        id={`start-job-${record.id}`}
                        onClick={() => onToggleScheduleStatus(record, true)}
                        disabled={!canEdit}
                        icon={<PlayCircleOutlined />}
                        type="primary"
                        data-cy="startSchedule"
                        visible={record.active === false}
                      >
                        Start
                      </Menu.Item>
                    )}
                  </Menu>
                }
              />
            </Space>
          );
        },
      },
    ];
  };

  // on mount, fetch all jobs
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setSchedules([]);
      await getSchedules();
      // getJobTypes is needed here for the Edit modal. TODO: refactor edit modal to use jobBuildInputs
      await getJobTypes();
      setLoading(false);
    };

    if (selectedClient) fetchData();
  }, [selectedClient]);

  useEffect(() => {
    form.setFieldsValue({
      ...inputFields,
    });
  }, [inputFields]);

  useEffect(() => {
    form.setFieldsValue({
      schedule_name: editedSchedule ? editedSchedule.name : null,
      job_type: editedSchedule ? editJobType : null,
      routing: editedSchedule ? JSON.stringify(editedSchedule.routing, null, 2) : null,
      ...inputFields,
    });
    if (editModal) handleGetInputFields();
  }, [form, editedSchedule]);

  // TODO: MOVE DRAWER AND MODALS TO THEIR OWN COMPONENTS
  return (
    <>
      <Drawer
        title={`Schedule New Job: ${selectedClient ? selectedClient.name : ''}`}
        placement="right"
        width="85%"
        bodyStyle={{ background: '#E9E8E9' }}
        headerStyle={{ background: '#E9E8E9' }}
        onClose={toggleNewJobScheduleDrawer}
        open={newSchedModal}
        destroyOnClose
        data-cy="job-scheduler-drawer"
        footer={false}
      >
        <Form
          form={form}
          name="createJob"
          onFinish={onCreateSchedule}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          validateTrigger="onSubmit"
        >
          <h3>Name</h3>
          <Form.Item
            name="schedule_name"
            initialValue={null}
            rules={[{ required: true, message: 'Schedule Name is required!' }]}
          >
            <Input
              rows={1}
              placeholder="Schedule Name"
              data-cy="scheduleName"
              maxLength={255}
              style={{ width: '95%' }}
              size="large"
            />
          </Form.Item>

          <h3 style={{ marginBottom: '0px' }}>Schedule Status</h3>
          <Form.Item name="active" label="">
            <Switch
              data-cy="scheduleStatus"
              id="select-schedule-status"
              placeholder="Select Schedule Status"
              defaultChecked={isActive}
              size="large"
              checkedChildren="Active"
              unCheckedChildren="Stopped"
              onClick={toggleIsActive}
            />
          </Form.Item>

          <JobBuildInputs
            selectedClient={selectedClient}
            form={form}
            // inputFields and hasRouteOn are needed to submit the form, so we need this state at parent level
            inputFields={inputFields}
            setInputFields={setInputFields}
            hasRouteOn={hasRouteOn}
            setHasRouteOn={setHasRouteOn}
          />
        </Form>

        <h3>Schedule</h3>
        {[cronJob]}

        <Popconfirm
          title={<div style={{ maxWidth: '250px' }}>{validateCron()}</div>}
          onConfirm={() => {
            form.submit();
          }}
          icon={
            <QuestionCircleOutlined
              style={{ color: validateCron() !== 'Are you sure?' ? 'red' : 'orange' }}
            />
          }
          okText="Create"
          okButtonProps={{ type: validateCron() !== 'Are you sure?' ? 'danger' : 'primary' }}
          style={{ wordWrap: true, width: '100px', background: '#28B5BE' }}
        >
          <Button
            style={{
              position: 'relative',
              background: '#28B5BE',
              color: 'white',
            }}
            size="large"
            htmlType="submit"
            data-cy="submit-job-scheduler-btn"
          >
            <PlusOutlined /> Create
          </Button>
        </Popconfirm>
        <Button
          style={{
            position: 'relative',
            right: -265,
          }}
          type="default"
          size="large"
          onClick={toggleNewJobScheduleDrawer}
          data-cy="close-job-scheduler-btn"
        >
          Close
        </Button>
      </Drawer>

      {/* MOVE TO OWN COMPONENT AND REFACTOR TO USE JobBuildInputs COMPONENT */}
      <Modal
        title="Edit Schedule Configuration"
        open={editModal}
        onCancel={toggleEditModal}
        footer={null}
        style={{ top: 10 }}
        width="80%"
        height="90%"
      >
        <Form
          form={form}
          name="editSchedule"
          onFinish={onSubmitEdit}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          validateTrigger="onSubmit"
        >
          <h4>Name</h4>
          <Form.Item
            name="schedule_name"
            rules={[{ required: true, message: 'Schedule Name is required!' }]}
          >
            <Input
              rows={1}
              placeholder="Schedule Name"
              data-cy="editScheduleName"
              maxLength={255}
              style={{ width: '95%' }}
              size="large"
            />
          </Form.Item>

          <h4 style={{ marginTop: '25px' }}>Job Type</h4>
          <Form.Item name="job_type" rules={[{ required: true, message: 'Job Type is required!' }]}>
            <Select
              showSearch
              style={{ width: '95%' }}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              filterSort={(optionA, optionB) =>
                (optionA?.label ?? '')
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? '').toLowerCase())
              }
              placeholder="Select Job Type"
              data-cy="editJobType"
              options={jobTypes}
              id="select-job-type"
              onChange={handleGetInputFields}
              size="large"
            />
          </Form.Item>

          <h3>Payload</h3>
          {Object.entries(inputFields).length > 0 ? (
            Object.keys(inputFields).map(key => {
              return (
                <Form.Item
                  name={key}
                  label={
                    <div>
                      {key}
                      <Tooltip placement="right" title={inputDescr[key]}>
                        <InfoCircleOutlined style={{ marginLeft: '5px' }} />
                      </Tooltip>
                    </div>
                  }
                  key={key}
                >
                  <Input id={key} style={{ width: '95%' }} />
                </Form.Item>
              );
            })
          ) : (
            <p>No input fields required for selected Job Type</p>
          )}
          <h3>Routing</h3>
          {hasRouteOn ? (
            <Form.Item name="routing" rules={[{ required: false }]}>
              <TextArea
                rows={1}
                placeholder="Routing"
                data-cy="editRouting"
                style={{ width: '95%' }}
                autoSize={{ minRows: 1, maxRows: 500 }}
                size="large"
              />
            </Form.Item>
          ) : (
            <p>Selected Job Type does not require Routing</p>
          )}

          <h4 style={{ marginTop: '25px' }}>Schedule</h4>
          {[cronJob]}

          <Popconfirm
            title={<div style={{ maxWidth: '250px' }}>{validateCron()}</div>}
            onConfirm={() => {
              form.submit();
            }}
            icon={
              <QuestionCircleOutlined
                style={{ color: validateCron() !== 'Are you sure?' ? 'red' : 'orange' }}
              />
            }
            okText="Edit"
            okButtonProps={{ type: validateCron() !== 'Are you sure?' ? 'danger' : 'primary' }}
            style={{ wordWrap: true, width: '100px', background: '#28B5BE' }}
          >
            <Button
              style={{
                background: '#28B5BE',
                color: 'white',
                marginTop: '25px',
              }}
              size="large"
              htmlType="submit"
              data-cy="submitEdit"
            >
              Save Changes
            </Button>
          </Popconfirm>
          <Button
            style={{
              alignSelf: 'flex-end',
              position: 'absolute',
              right: 35,
              marginTop: '25px',
            }}
            type="default"
            size="large"
            onClick={toggleEditModal}
            data-cy="close-job-scheduler-btn"
          >
            Close
          </Button>
        </Form>
      </Modal>

      {/* MOVE TO OWN COMPONENT */}
      <Modal
        title="Delete Scheduled Job"
        open={deleteModal}
        onOk={handleDeleteSchedule}
        onCancel={e => [e.stopPropagation(), setDeleteModal(false)]}
        footer={null}
      >
        <h4>Name</h4>
        <p>{editedSchedule ? editedSchedule.name : null}</p>
        <h4 style={{ marginTop: '25px' }}>Job Type</h4>
        <p>{jobTypeDesc}</p>
        <h4 style={{ marginTop: '25px' }}>Schedule</h4>
        <p style={{ marginBottom: '35px' }}>{readableCronString(cronString)}</p>

        <Popconfirm
          title="Are you sure?"
          onConfirm={handleDeleteSchedule}
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
        >
          <Button size="large" danger type="primary" data-cy="deleteScheduleBtn">
            <DeleteOutlined /> Delete
          </Button>
        </Popconfirm>
        <Button
          style={{
            alignSelf: 'flex-end',
            position: 'absolute',
            right: 35,
          }}
          type="default"
          size="large"
          onClick={toggleDeleteModal}
          data-cy="close-job-scheduler-btn"
        >
          Close
        </Button>
      </Modal>

      <Button
        style={{
          marginTop: 'auto',
          marginRight: 10,
          float: 'right',
          background: '#28B5BE',
          color: 'white',
        }}
        disabled={!canEdit}
        onClick={() => toggleNewJobScheduleDrawer()}
        data-cy="toggle-job-scheduler-btn"
        size="large"
      >
        <PlusCircleOutlined /> New Schedule
      </Button>

      <br />
      <br />
      <Spin spinning={isLoading}>
        <Table
          dataSource={[...schedules]}
          columns={generateColumns()}
          pagination={{ pageSize: 100 }}
          loading={isLoading}
          rowClassName={row => (row.active === false ? 'table-row-dark ' : 'table-row-light')}
        />
      </Spin>
    </>
  );
};

export default Schedules;
